import React, {memo, useEffect, useRef, useState } from 'react'
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list';
import { Col, Container, Row } from 'react-bootstrap'
import Footer from '../../components/ui/Footer'
import Logo from '../../components/ui/Logo'
import SideOptionsPanel from '../../components/ui/SideOptionsPanel';
import { Timestamp, addDoc, collection, getDocs } from 'firebase/firestore'
import { db } from '../../firebase'
// import EFFECT from 'vanta/dist/vanta.clouds.min.js'
// import * as THREE from "three"; // Importing THREE.js
import { useAuth } from '../../contexts/AuthContext';
import Header from '../../components/ui/Header';
import { Link } from 'react-router-dom';

const AppointmentCalendar = () => {
    const [services, setServices] = useState([]);
    const [appointments, setAppointments] = useState([]);
    // const [vantaEffect, setVantaEffect] = useState(null)
    const { currentUser, userId } = useAuth();
    const servicesCollectionName = 'Services';
    const appointmentCollectionName = 'Appointments'
    const [serviceServicesCol, setServiceServicesCol] = useState();


    useEffect(() => {
        const getServices = async () => {
            // Get services from Firestore DB 
            const data = await getDocs(collection(db, servicesCollectionName));
            setServices(data.docs.map((doc) => ({ ...doc.data(), id: doc.id})));
        }

        const getAppointments = async () => {
            // Get services from Firestore DB 
            const data = await getDocs(collection(db, appointmentCollectionName));
            setAppointments(data.docs.map((doc) => ({ 
                title: doc && doc.data() && doc.data().title,
                start: doc && doc.data() && doc.data().start && new Date(doc.data().start.seconds * 1000).toISOString(),
                end: doc && doc.data() && doc.data().end && new Date(doc.data().end.seconds * 1000).toISOString() })));
        }

        getServices();
        getAppointments();

        
        
        console.log(services, appointments, currentUser && currentUser.providerData)
    }, []);

    useEffect(() => {
        setServiceServicesCol(<Col md={'3'}>
            <SideOptionsPanel 
                heading={'Services to Book'} 
                description={'Please Login First to Book Services'} 
                options={''} />    
            </Col>) 
        
           if(currentUser)
                setServiceServicesCol(<Col md={'3'}>
                    <SideOptionsPanel 
                        heading={'Services to Book'} 
                        description={'Drag a service to the calendar to create an appointment'} 
                        options={services} />    

                    <Link to={"/appointment-management/create-appointment"} type="button" 
                        className={'btn text-white btn-secondary my-4'}>Add New Appointment By Form</Link>
                </Col>)
    }, [services]);

    const handleEventDrop = (info) =>  {
        console.log("Triggered ", info);

        if(!currentUser){
            window.alert("You are not Logged In, Please do so before creating Appointments");
            info.revert();
            return;
        }

        window.alert(info.event.title + " was dropped on " + info.event.start);
    
        if (!window.confirm("Are you sure you want to make this appointment?")) {
            info.revert();
            return;
        }
        
        submitAppointmentEvent(info);
    }

   const submitAppointmentEvent = async (info) =>  {
    console.log(info.event, info.event.end);

        const { id } = await addDoc(collection(db, appointmentCollectionName), {
            title: info.event.title,
            start:Timestamp.fromDate(info.event.start),
            end:Timestamp.fromDate(info.event.end),
            user: currentUser.providerData[0],
            uid: userId,
            service: info.event.extendedProps.service
        });

        return id;
   }

 
  return (
    <div className='txt-green'>
        <Header>
            <h2 className='text-center text-dark thick-font sub-header-txt-shadow'>Appointment Calendar</h2>
        </Header>

    <Container className='my-3'>
        <Row>
            {serviceServicesCol}
            <Col className='bk-mint rounded p-3'>
                <FullCalendar
                    plugins={[ timeGridPlugin, listPlugin, interactionPlugin ]}
                    headerToolbar = { {center: 'timeGridWeek,timeGridDay,listWeek'} }
                    initialView="timeGridWeek"      
                    slotMinTime={'08:00:00'}
                    slotMaxTime={'17:00:00'}
                    eventBackgroundColor='#E03D4D'
                    eventTextColor = '#000'
                    eventClassNames={'thick-font'}
                    contentHeight = 'auto'
                    droppable={true}
                    selectable={true}
                    allDaySlot={false}
                    weekends={false}
                    eventReceive={handleEventDrop}
                    events={appointments}
                    id={'appointmentCalendar'} />
            </Col>
        </Row>
    </Container>

    <Footer></Footer>
    </div>
  )
}

export default memo(AppointmentCalendar);
